module.exports = __webpack_public_path__ + "img/cluster-icon.4eee36f8.svg";